import { IModalProps, Modal, Button } from '@/shared/ui';
import { useChatClassName } from '@/shared/hooks/useChatClassName';
import Bottles from '@/assets/images/onboarding/bottles.png';

type IProps = Omit<IModalProps, 'children'>;


const GreyHeadingAndSubheading = ({ heading, subText }: { heading: string; subText: string; }) => {
    return (
        <div className='flex flex-col items-start justify-center'>
            <span className='block text-[#9FA4A1] font-atkinsonBold text-12 sm:text-16 mb-[5px]'>
                {heading}
            </span>
            <span className='block font-atkinson text-14 sm:text-20'>
                {subText}
            </span>
        </div>
    )
}


export default (props: IProps) => {
    const chatClassName = useChatClassName();

    return (
        <Modal
            {...props}
            className=""
            contentClassName="!max-w-[350px] sm:!max-w-[488px] px-[25px] py-[25px] pt-[30px] sm:px-[40px] sm:py-[40px]"
            dataTestId="need-sooner"
        >
            <div className='flex flex-col items-center justify-center' data-testid="need-sooner-container">
                <img src={Bottles} alt="Bottles" className='w-[100px] sm:w-[128px]' />
                <span className='leading-[130%] mb-2 block font-agrandir text-25 sm:text-30 text-center' data-testid="need-sooner-title">
                    Need medications ASAP?<br />
                    We’ve got you
                </span>
                <span className='leading-[130%] block mb-5 font-atkinsonHyperlegible text-15 sm:text-18 text-center' data-testid="need-sooner-content-text">
                    If you need a refill or new prescription urgently, we’ll take care of it right away. Your MedBox Care Advisor is <span className="whitespace-nowrap">standing by.</span>
                </span>
                <Button
                    showEndIcon
                    className={`${chatClassName} w-full`}
                    onClick={props.onClose}
                    sx={{ boxShadow: '0px 4px 7.1px 0px #0000000F' }}
                    testId="button-need-sooner-chat"
                    fontClassName='font-bold'
                >
                    <span className="my-[0.375rem] text-16 md:text-18 font-dmSans font-bold" data-testid="need-sooner-chat-text">Chat with Us</span>
                </Button>
            </div>
        </Modal >
    );
}